import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#141329',
        padding: '6px 0 36px 0',
        [theme.breakpoints.down('md')]: {
            padding: '24px 0px 16px 0px',
        },
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        boxSizing: 'border-box',
        maxWidth: '1366px',
        [theme.breakpoints.down('md')]: {
            padding: '0 24px',
        },
    },
    title: {
        margin: 0,
        fontSize: 48,
        fontWeight: 800,
        color: '#fff',
        lineHeight: '58px',
        textAlign: 'center',
        [theme.breakpoints.down('md')]: {
            fontSize: 30,
            lineHeight: '36px',
        },
    },
    imageContainer: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        '& > img': {
            objectFit: 'contain',
        },
        [theme.breakpoints.down('md')]: {
            justifyContent: 'flex-start',
            overflowX: 'auto',
            WebkitOverflowScrolling: 'touch',
            width: '100vw',
            marginLeft: 'calc(50% - 50vw)',
            marginRight: 'calc(50% - 50vw)',
            padding: '0 24px 8px',
            boxSizing: 'border-box',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            '&::-webkit-scrollbar': {
                display: 'none',
            },
        },
    },
    desktopImage: {
        width: '100%',
        height: 'auto',
        objectFit: 'contain',
    },
    mobileImage: {
        width: 'min(920px, 190vw)',
        maxWidth: 'none',
        flexShrink: 0,
        height: 'auto',
        objectFit: 'contain',
    },
    titleContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 28,
        [theme.breakpoints.down('md')]: {
            marginBottom: 32,
        },
    },
    description: {
        fontSize: 20,
        fontWeight: 500,
        color: '#D1D5DB',
        lineHeight: '32px',
        textAlign: 'center',
        maxWidth: '540px',
        marginTop: 8,
        [theme.breakpoints.down('md')]: {
            fontSize: 18,
            lineHeight: '30px',
        },
    }
}));

export default useStyles;
